import { render, staticRenderFns } from "./chatContent.vue?vue&type=template&id=8cdf50bc&scoped=true"
import script from "./chatContent.vue?vue&type=script&lang=ts"
export * from "./chatContent.vue?vue&type=script&lang=ts"
import style0 from "./chatContent.vue?vue&type=style&index=0&id=8cdf50bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdf50bc",
  null
  
)

export default component.exports